<!-- MODAL resumen producto -->
<div style="overflow-y: auto;" mdbModal #resumenProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">Consulta del producto - SKU
                    <span>{{producto?.sku}}</span>
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="resumenProducto.hide()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-3">
                        <div class="waves-input-wrapper waves-light" mdbWavesEffect>
                        <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verDetalle()" mdbRadio="detalle">
                            Resumen Producto
                        </label>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="waves-input-wrapper waves-light" mdbWavesEffect>
                        <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verAuditoria()" mdbRadio="auditoria">
                            Auditoria Producto
                        </label>
                        </div>
                    </div>
                </div>
                <form [formGroup]="formResumen">
                    <ng-container *ngIf="currentTabs === 'detalle'">
                        <div class="row">
                            <div class="col">
                                <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos del producto</h5>
                            </div>
                            <div class="col">
                                <Strong class="title">Estado: </Strong>
                                <span class="value" *ngIf="producto?.activo">
                                    <mdb-badge pill="true" success="true">Activo</mdb-badge>
                                </span>
                                <span class="value" *ngIf="!producto?.activo">
                                    <mdb-badge pill="true" danger="true">Inactivo</mdb-badge>
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Left -->
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input formControlName="sku" value="" type="text" id="rsku" class="form-control"
                                                placeholder="SKU" #sku />
                                            <label for="sku">SKU</label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <!--Rounded checkbox buttons-->
                                        <div class="btn-group">
                                            <label mdbBtn color="warning" rounded="true"
                                                class="active form-check-label favorito" formControlName="favorito"
                                                mdbCheckbox mdbWavesEffect>
                                                <mdb-icon fas icon="star"></mdb-icon>
                                            </label>
                                        </div>
                                        <!--Rounded checkbox buttons-->
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input value="" formControlName="codigo_barras" type="text" id="rcodigoBarra"
                                                class="form-control" placeholder="Código de barra" #codigoBarra />
                                            <label for="codigoBarra">Código de barra</label>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input formControlName="descripcion" value="" type="text" id="rdescripcion" class="form-control"
                                                placeholder="Descripción" #descripcion />
                                            <label for="descripcion">Descripción</label>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input formControlName="descripcion_ext" value="" type="text" id="rmarca" class="form-control" placeholder="Marca"
                                                #marca />
                                            <label for="marca">Marca</label>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input formControlName="unidad_medida" value="" type="text" id="runidad" class="form-control"
                                                placeholder="Unidad de Medida" #unidad />
                                            <label for="unidad">Unidad de Medida</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <!-- Right -->
                            <div class="col">
                                <div class="row">
                                <div class="col">
                                    <strong>Fecha de creación: </strong> <span>{{producto?.fecha_registro | fecha}}</span>
                                
                                    <div class="md-form">
                                        <input formControlName="rubro" value="" type="text" id="rrubro" class="form-control" placeholder="Rubro"
                                            #rubro />
                                        <label for="rubro">Rubro</label>
                                    </div>
                                </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input formControlName="familia" value="" type="text" id="rfamilia" class="form-control" placeholder="Familia"
                                                #familia />
                                            <label for="familia">Familia</label>
                                        </div>
                                    
                                    
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form" *ngIf="parametroNegocio">
                                            <input formControlName="unidad_negocio" value="" type="text" id="runidad_negocio" class="form-control"
                                                placeholder="Unidad Negocio" #unidad_negocio />
                                            <label for="unidad_negocio">Unidad Negocio</label>
                                        </div>
                                    
                                    
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            Seleccionar impuesto adicional
                                            <button type="button" size="sm" mdbBtn color="info" (click)="showModalImpuestos()" mdbWavesEffect>
                                                ...
                                            </button>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <Strong class="title">Exento de IVA: </Strong>
                                            <span class="value" *ngIf="producto?.es_exento">
                                                <mdb-badge pill="true" success="true">Activo</mdb-badge>
                                            </span>
                                            <span class="value" *ngIf="!producto?.es_exento">
                                                <mdb-badge pill="true" danger="true">Inactivo</mdb-badge>
                                            </span>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <Strong class="title">No afecto a reglas comerciales: </Strong>
                                            <span class="value" *ngIf="producto?.afecto_reglas_comerciales">
                                                <mdb-badge pill="true" success="true">Activo</mdb-badge>
                                            </span>
                                            <span class="value" *ngIf="!producto?.afecto_reglas_comerciales">
                                                <mdb-badge pill="true" danger="true">Inactivo</mdb-badge>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
    
                        <table class="table table-striped table-hover table-sm align-middle">
                            <thead class="grey lighten-2">
                                <tr>
                                    <th scope="col">Formato</th>
                                    <th scope="col">Peso (Kg)</th>
                                    <th scope="col">Volumen</th>
                                    <th scope="col">Factor</th>
                                    <th scope="col" class="text-center">Formato Princ.</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="!listaProductoFormatoResumen || listaProductoFormatoResumen.length === 0">
                                    <td colspan="6" style="text-align: center">Agregue Formato</td>
                                </tr>
                                <tr *ngFor="let pro_for of listaProductoFormatoResumen">
                                    <td>{{ pro_for.formato_nombre }}</td>
                                    <td>{{ pro_for.peso_neto }}</td>
                                    <td>{{ pro_for.volumen }}</td>
                                    <td>{{ pro_for.cantidad }}</td>
                                    <td class="text-center">
                                        <div class="text-center" *ngIf="pro_for.formato_codigo == pro_for.formato_codigo_top">
                                            <mdb-badge pill="true" success="true">Principal</mdb-badge>
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="pro_for.activo">
                                            <mdb-badge pill="true" success="true">Activo</mdb-badge>
                                        </div>
                                        <div *ngIf="!pro_for.activo">
                                            <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
    
                        <div class="row">
                            <div class="col">
                                <h4>Datos comerciales</h4>
                            </div>
                        </div>
    
                        <div class="row align-items-center">
                            <div class="col" style="min-width: 50%;">
                                <div class="md-form">
                                    <mdb-select formControlName="formato" label="Seleccionar Formato"
                                        [options]="optionsFormatoProducto" placeholder="Formato"></mdb-select>
                                </div>
                            </div>
                            <div class="col">
                                <strong>Precio de costo: </strong> <span>$ 1.200</span>
                            </div>
                        </div>
    
                        <div class="row mt-1">
                            <div class="col">
                                <table class="table table-striped table-hover table-sm align-middle">
                                    <thead>
                                        <tr class="grey lighten-2">
                                            <th scope="col"></th>
                                            <th scope="col">Lista 1</th>
                                            <th scope="col">Lista 2</th>
                                            <th scope="col">Lista 3</th>
                                            <th scope="col">Lista 4</th>
                                            <th scope="col">Lista 5</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td scope="col">Neto ($)</td>
                                            <td>{{ neto_1 | numerico }}</td>
                                            <td>{{ neto_2 | numerico  }}</td>
                                            <td>{{ neto_3 | numerico  }}</td>
                                            <td>{{ neto_4 | numerico  }}</td>
                                            <td>{{ neto_5 | numerico  }}</td>
                                        </tr>
                                        <tr>
                                            <td scope="col">Margen (%)</td>
                                            <td>{{margen_1 | numerico}}</td>
                                            <td>{{margen_2 | numerico}}</td>
                                            <td>{{margen_3 | numerico}}</td>
                                            <td>{{margen_4 | numerico}}</td>
                                            <td>{{margen_5 | numerico}}</td>
                                        </tr>
                                        <tr>
                                            <td scope="col">IVA [{{parametro_iva}}%]</td>
                                            <td>{{ iva1 | numerico}}</td>
                                            <td>{{ iva2 | numerico}}</td>
                                            <td>{{ iva3 | numerico}}</td>
                                            <td>{{ iva4 | numerico}}</td>
                                            <td>{{ iva5 | numerico}}</td>
                                        </tr>
                                        <tr>
                                            <td scope="col">Impto. Adic. [{{impuestoAdicPro}}%]</td>
                                            <td>{{ impAdicional1 | numerico}}</td>
                                            <td>{{ impAdicional2 | numerico}}</td>
                                            <td>{{ impAdicional3 | numerico}}</td>
                                            <td>{{ impAdicional4 | numerico}}</td>
                                            <td>{{ impAdicional5 | numerico}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="grey lighten-2">
                                            <th scope="col">Precio Final</th>
                                            <th scope="col">{{ preciofinal1 | numerico}}</th>
                                            <th scope="col">{{ preciofinal2 | numerico}}</th>
                                            <th scope="col">{{ preciofinal3 | numerico}}</th>
                                            <th scope="col">{{ preciofinal4 | numerico}}</th>
                                            <th scope="col">{{ preciofinal5 | numerico}}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </form>
                <app-lista-auditoria *ngIf="currentTabs === 'auditoria'" [auditoria]="auditoria"></app-lista-auditoria>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="resumenProducto.hide()" mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL seleccionImpuesto -->
<app-producto-modal-seleccionar-impuesto (onImpuestoSeleccionado)="capturaImpuesto($event)">
</app-producto-modal-seleccionar-impuesto>